export class ContactValidationFilter {
    public IncludeInactive?: boolean;
}

export default ContactValidationFilter;